import { render, staticRenderFns } from "./vat-switch.vue?vue&type=template&id=6afcfdbf&"
import script from "./vat-switch.vue?vue&type=script&lang=js&"
export * from "./vat-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports